import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { forwardRef as h } from "react";
const l = ({
  title: e,
  titleId: o,
  ...t
}, d) => /* @__PURE__ */ i("svg", { viewBox: "0 0 24 24", width: "1.2em", height: "1.2em", ref: d, "aria-labelledby": o, ...t, children: [
  e ? /* @__PURE__ */ r("title", { id: o, children: e }) : null,
  /* @__PURE__ */ i("g", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, children: [
    /* @__PURE__ */ r("path", { d: "m12 15l2 2l4-4" }),
    /* @__PURE__ */ r("rect", { width: 14, height: 14, x: 8, y: 8, rx: 2, ry: 2 }),
    /* @__PURE__ */ r("path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" })
  ] })
] }), s = h(l);
export {
  s as default
};
//# sourceMappingURL=copy-check.js.map
